import { Subscribe } from "@/widgets/classic-form/form";
import { Clear } from "./Clear";

export interface ClearSectionProps {
    label?: string;
}

export const ClearSection = ({ label }: ClearSectionProps) => (
    <Subscribe
        selector={({ isDirty, isValid, isSubmitting, values: { treePerson } }) => {
            const disabled = treePerson.treeId ? false : !isDirty || !isValid || isSubmitting;

            return {
                disabled,
            };
        }}
        children={({ disabled }) => <Clear label={label} disabled={disabled} />}
    />
);
